/*
 * Paths available across all locales - no redirect to homepage needed
 * */
export const globalPaths = ['/cookies', '/ebikes', '/bikes'];
